import React from 'react';
import PropTypes from 'prop-types';
import helpers from '../../resources/helpers';

import SelectList from '../form-elements/SelectList';

class StateList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			options: [],
		};
	}

	async componentDidMount() {
		let options = this.props.options;
		if (!options) {
			options = await helpers.loadAemFormData('/formfragments/addressFormElements', 'guidedropdownlist');
		}
		this.setState({ options });
	}

	getValue() {
		return this.selectList.props.value;
	}

	render() {
		return (
			<SelectList
				innerRef={(c) => (this.selectList = c)}
				label={this.props.label || 'State / Province'}
				optionalLabel={this.props.optionalLabel}
				name={this.props.name || 'state'}
				options={this.state.options}
				required={this.props.required}
				showError={this.props.showError}
				errorMessage={this.props.errorMessage || 'Please Select a State'}
				value={this.props.value}
				onChange={this.props.onChange}
				formHasHadAnInValidSubmit={this.props.formHasHadAnInValidSubmit}
			/>
		);
	}
}

StateList.propTypes = {
	label: PropTypes.string,
	optionalLabel: PropTypes.string,
	name: PropTypes.string,
	options: PropTypes.array,
	required: PropTypes.bool,
	showError: PropTypes.any,
	errorMessage: PropTypes.string,
	value: PropTypes.string,
	onChange: PropTypes.func,
	getValue: PropTypes.func,
	formHasHadAnInValidSubmit: PropTypes.bool,
};

export default StateList;
